import * as React from 'react';

export interface ILinkProps {
  icon: string;
  label: string;
  location: string;
}

export class Link extends React.Component<ILinkProps> {
  constructor(props: any, context: any) {
    super(props, context);
  }

  public render() {
    const { icon, label, location } = this.props;
    return (
      <a className="link-material" href={location}><img
        height="20"
        className="image"
        src={`https://raw.githubusercontent.com/csharptest/nms/master/img/${icon}.png`}
      />{label}</a>
    );
  }
}

export default Link;



// WEBPACK FOOTER //
// ./src/Link.tsx